"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../helpers/numberFormatter");
var level1DataProp = _interopRequireWildcard(require("../../propTypes/level1Data"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _instrumentPropTypes = require("../../propTypes/instrumentPropTypes");
var _InstrumentTableItem = _interopRequireDefault(require("./InstrumentTableItem"));
var _useUTCDateTime = require("./useUTCDateTime");
var _useFundingCountDown = require("./useFundingCountDown");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("./../InstrumentTable/InstrumentTableComponent.css");
require("./FuturesInstrumentTableComponent.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UTCClockItem = /*#__PURE__*/_react["default"].memo(function UTCClockItem(_ref) {
  var baseClasses = _ref.baseClasses;
  var _useUtcTime = (0, _useUTCDateTime.useUtcTime)(),
    formattedTime = _useUtcTime.formattedTime,
    formattedDate = _useUtcTime.formattedDate;
  return /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: formattedTime,
    valueCurrency: "UTC",
    label: formattedDate,
    baseClasses: baseClasses
  });
});
var FundingCountdownItem = /*#__PURE__*/_react["default"].memo(function FundingCountdownItem(_ref2) {
  var baseClasses = _ref2.baseClasses,
    t = _ref2.t;
  var _useFundingCountdown = (0, _useFundingCountDown.useFundingCountdown)(),
    fundingCountdown = _useFundingCountdown.fundingCountdown;
  return /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: fundingCountdown,
    label: t('Countdown'),
    labelTooltip: t('Time remaining until the next funding payment is exchanged between long and short positions.'),
    baseClasses: baseClasses
  });
});
var InstrumentTableComponent = function InstrumentTableComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var fetching = props.fetching,
    level1 = props.level1,
    selectedInstrument = props.selectedInstrument,
    marketOverview = props.marketOverview;
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['instrument-table', marketOverview ? 'market-overview-instrument' : '']);
  var product1Symbol = selectedInstrument.Product1Symbol;
  var product2Symbol = selectedInstrument.Product2Symbol;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('', 'futures')
  }, fetching ? /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, marketOverview && /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title')
  }, t('{{venueSymbol}} Price Data', {
    venueSymbol: "".concat(product1Symbol).concat(product2Symbol)
  }), ":")), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.LastTradedPx, 2),
    valueCurrency: selectedInstrument.Product2Symbol,
    valueTooltip: t('Price at which the most recent trade on this exchange occurred.'),
    label: (0, _numberFormatter.formatNumberToLocale)(level1.PxChange, 2),
    labelTooltip: t('Absolute price difference of this contract over the last 24 hours.'),
    secondLabel: "".concat((0, _numberFormatter.formatPercentageValue)(level1.PxChangePercent)),
    secondLabelTooltip: t('Percentage price change of this contract over the last 24 hours.'),
    baseClasses: baseClasses,
    classModifiers: [level1.PxChange >= 0 ? 'title-24h-positive' : 'title-24h-negative', level1.PxChangePercent >= 0 ? 'second-title-24h-positive' : 'second-title-24h-negative']
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.MarkPrice, 2),
    valueCurrency: selectedInstrument.Product2Symbol,
    label: t('Mark'),
    labelTooltip: t('Estimated fair value used for P&L calculations and to trigger liquidations; protects against price manipulation.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.IndexPrice, 2),
    valueCurrency: selectedInstrument.Product2Symbol,
    label: t('Index'),
    labelTooltip: t('Average spot price of the underlying asset, aggregated from major exchanges.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: "".concat((0, _numberFormatter.formatPercentageValue)(level1.FundingRate * 100)),
    label: t('Funding'),
    labelTooltip: t('Periodic payments exchanged between long and short positions to keep the contract price close to the spot price.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(FundingCountdownItem, {
    t: t,
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.Volume, 0),
    valueCurrency: selectedInstrument.Product1Symbol,
    label: t('24 Hour Volume'),
    labelTooltip: t('Total volume traded over the last 24 hours, expressed in the base currency.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.TurnoverVolume, 0),
    valueCurrency: selectedInstrument.Product2Symbol,
    label: t('24 Hour Volume'),
    labelTooltip: t('Total volume traded over the last 24 hours, expressed in the quoted currency.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: "".concat((0, _numberFormatter.formatNumberToLocale)(level1.SessionLow, 2), " / ").concat((0, _numberFormatter.formatNumberToLocale)(level1.SessionHigh, 2)),
    valueCurrency: selectedInstrument.Product2Symbol,
    label: t('24 Hour Low'),
    labelTooltip: t('The lowest price at which this contract has traded in the last 24 hours.'),
    labelDivider: "/",
    secondLabel: "".concat(t('High')),
    secondLabelTooltip: t('The highest price at which this contract has traded in the last 24 hours.'),
    baseClasses: baseClasses
  }), /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
    value: (0, _numberFormatter.formatNumberToLocale)(level1.OpenInterest, 0),
    valueCurrency: selectedInstrument.Product2Symbol,
    label: t('Open Interest'),
    labelTooltip: t('Total number of outstanding futures contracts that have not yet been closed or settled.'),
    baseClasses: baseClasses
  }), !marketOverview && /*#__PURE__*/_react["default"].createElement(UTCClockItem, {
    baseClasses: baseClasses
  })));
};
InstrumentTableComponent.propTypes = {
  marketOverview: _propTypes["default"].bool,
  level1: level1DataProp.type.isRequired,
  selectedInstrument: _instrumentPropTypes.instrumentPropType,
  fetching: _propTypes["default"].bool,
  decimalPlacesP1: _propTypes["default"].number,
  decimalPlacesP2: _propTypes["default"].number
};
InstrumentTableComponent.defaultProps = {
  marketOverview: false,
  level1: level1DataProp.defaultProps,
  fetching: false,
  decimalPlacesP1: 2,
  decimalPlacesP2: 2
};
var _default = exports["default"] = InstrumentTableComponent;